export default "__VITE_PUBLIC_ASSET__48a08c47__"